import { createContext, useContext } from "react";
import useApplications from "../hooks/useApplications";

/**
 * The application list is shared across the whole dashboard subtree — the sidebar nav lists
 * them, the dashboard page shows them as cards, and each application page reads one of them —
 * so it is fetched once here instead of per page.
 */
const ApplicationsContext = createContext(null);

export function ApplicationsProvider({ children }) {
  const value = useApplications();
  return <ApplicationsContext.Provider value={value}>{children}</ApplicationsContext.Provider>;
}

export function useApplicationsContext() {
  const context = useContext(ApplicationsContext);
  if (context === null) {
    throw new Error("useApplicationsContext must be used inside <ApplicationsProvider>");
  }
  return context;
}
